import Vue from 'vue';
import * as filters from '@/filters';
import * as directives from '@/directives';
import localStorage from '@/libs/localStorage';
import bowser from 'bowser';
import baseFn from '@/utils/base';
import store from '@/store';
import waterfall from '@/plugins/Waterfall';
import App from './App.vue';
import router from './router';
import '@/assets/scss/demo1.scss';

import '@/plugins/element';
import '@/plugins/wxjssdk';

Vue.config.productionTip = process.env.NODE_ENV === 'development';

Vue.prototype.$localStorage = localStorage;
Vue.prototype.$bowser = bowser;
Vue.prototype.$screenHeight = window.innerHeight;
Vue.prototype.$bowser.mobile = bowser.mobile || window.innerWidth <= 750;

Vue.prototype.$members = [
  {
    id: 1,
    cover: require('@/assets/images/demo1/about/t-1.jpg'),
    name: {
      cn: '齐胜利',
      en: 'Qi Shengli',
    },
    title: {
      cn: '总建筑师｜创意总监｜总裁',
      en: 'Chief Architect｜Creative Director｜President',
    },
    content: '同济大学建筑城市规划硕士\r\n比利时鲁汶大学建筑学硕士\r\n高级环境艺术设计师',
    awards:
      '中国年度设计人物\r\n全国百名优秀室内建筑师\r\n中国资深酒店设计师\r\n中国饭店协会常务理事\r\n亚洲民宿精品酒店协会副理事长\r\n广东省装饰业协会常务副会长\r\n集美组前总裁原创者之一',
  },
  {
    id: 2,
    cover: require('@/assets/images/demo1/about/t-2.jpg'),
    name: {
      cn: '刘鹰',
      en: 'Liu Ying',
    },
    title: {
      cn: '副总建筑师｜一级注册建筑师',
      en: 'Deputy Chief Architect,First-Class Registered Architect',
    },
    content:
      '刘鹰先生从事建筑设计工作18年，主导及参与国内多个五星级度假酒店及地产开发的建筑设计，曾担任广州长隆酒店扩建工程建筑专业负责人及设计方驻场代表全程负责项目现场设计及建设。凭借多年设计从业经验，为酒店及地产客户提供极具创意及理性设计服务。',
    awards:
      '北京市第十四庙建筑设计评选中“河南郑州建业联盟新城三期”获“二等奖”\r\n第八界国际室内设计双年展评选中“广州南湖宾馆建筑设计”获“银奖”\r\n第四届海峡两岸四地设计大赛“广州长隆酒店扩建工程”公共建筑方案“铜奖”\r\n第四届海峡两岸四地设计大赛“中山清华坊”住宅建筑工程“铜奖”',
  },
  {
    id: 3,
    cover: require('@/assets/images/demo1/about/t-3.jpg'),
    name: {
      cn: '张楚洪',
      en: 'zhang chuhong',
    },
    title: {
      cn: '创意总监｜副总建筑师',
      en: 'Creative Director,Deputy Chief Architect',
    },
    content:
      '张楚洪先生 2007年毕业于广州美术学院建筑与环境艺术系，并从事建筑艺术工作至今，致力于“美学”与“功能”的研究探索，并力求为使用者提供更具前瞻性与适应性的创意与设计。',
    awards:
      '第八届中国国际室内设计双年展铜奖（开封西北湖湿地会馆）\r\n首届中南地区国际空间环境艺术设计大赛金奖（丽水养生文化园）\r\n第八届中国设计双年展银奖（白盆珠温泉度假酒店）\r\n第八届中国设计双年展银奖（嘉兴湘家荡环湖公园休闲文化中心）\r\n第八届中国设计双年展优秀奖（嘉兴湘家荡江南水乡古村）\r\n入选第八届全国环境艺术设计大展（丽江美林梦丝路小镇）',
  },
  {
    id: 4,
    cover: require('@/assets/images/demo1/about/t-4.jpg'),
    name: {
      cn: '曾福勇',
      en: 'zeng fuyong',
    },
    title: {
      cn: '副总建筑师 | 一级注册建筑工程师',
      en: 'Deputy Chief Architect | First Class Construction Engineer',
    },
    content: '曾福勇先生 1995 年毕业于浙江大学建筑学专业，毕业以来一直从事建筑设计工作，担任大量工程项目的设计负责人，擅长住区规划及公共建筑设计。',
    awards:
      '海口市世纪大桥监控管理中心，荣获2005 年海南省优秀建筑设计三等奖，《中国勘察设计》当代中国青年建筑师优秀作品大赛二等奖\r\n广州佳信花园，荣获2008 年度广州市优秀工程勘察设计二等奖，2009 年度广东省优秀工程勘察设计三等奖',
  },
  {
    id: 5,
    cover: require('@/assets/images/demo1/about/t-5.jpg'),
    name: {
      cn: '陈海利',
      en: 'chen haili',
    },
    title: {
      cn: '创意总监 | 副总建筑师',
      en: 'Creative Director | Deputy Chief Architect',
    },
    content:
      '陈海利先生 2009年毕业于广州美术学院建筑学院，并从事设计至今，主要以度假酒店、精品酒店、建筑改造更新、小型建筑等创新设计为主要方向。',
    awards:
      '首届中南地区国际空间环境艺术设计大赛金奖\r\n第八届中国设计双年展银奖\r\n第八届中国设计双年展银奖\r\n第八届中国设计双年展优秀奖\r\n入选第八届全国环境艺术设计大展',
  },
  {
    id: 6,
    cover: require('@/assets/images/demo1/about/t-6.jpg'),
    name: {
      cn: '周海新',
      en: 'zhou haixin',
    },
    title: {
      cn: '设计总监',
      en: 'Design Director',
    },
    content:
      '周海新先生，以跨界融合的思维方式提供创新的设计理念，创造充满活力的空间体验，注重对每一个项目的深入调研，以系统并严谨的专业手法，力求打造出富有独特情感的体验空间。',
    awards:
      '2013 CIID中国五十位优秀青年室内设计师\r\n2016 中国（广州）室内设计新势力设计师\r\n2019 中国（广州）室内设计TOP10设计师\r\n广州美术学院建筑与环境艺术设计系 本科\r\n中国建筑学会室内设计分会 广州专委会理事\r\n中国室内装饰协会CIDA 理事会员\r\n广东省陈设艺术协会 理事会员',
  },
  {
    id: 7,
    cover: require('@/assets/images/demo1/about/t-7.jpg'),
    name: {
      cn: '邱延飞',
      en: 'qiu yanfei',
    },
    title: {
      cn: '结构总负责人 | 一级注册结构工程师',
      en: 'Head of Structure | First-level Structural Engineer',
    },
    content: '邱延飞先生 2001年毕业于华东船舶工业学院建筑工程专业，毕业以来一直从事建筑结构设计工作，负责或参与过较多工程项目结构设计工作。',
    awards:
      '',
  },
  {
    id: 8,
    cover: require('@/assets/images/demo1/about/t-8.jpg'),
    name: {
      cn: '钟异珍',
      en: 'zhong yizhen',
    },
    title: {
      cn: '总工程师 | 高级工程师',
      en: 'Chief Engineer | Senior Engineer',
    },
    content:
      '钟异珍女士 1994年毕业于广东省成人科技大学工业与民用建筑专业,后于2006年广东工业大学修完建筑学专业毕业,毕业二十多年一直从事设计工作, 主持多个“中国风”项目,参与国内多个五星级度假酒店及地产开发的建筑设计,为客户提供建筑一体化设计提供优质服务。',
    awards:
      '',
  },
  {
    id: 9,
    cover: require('@/assets/images/demo1/about/t-9.jpg'),
    name: {
      cn: '杨瑞文',
      en: 'yang ruiwen',
    },
    title: {
      cn: '设备总负责人 | 高级暖通工程师',
      en: 'Chief Equipment Officer | Senior Hutong Engineer',
    },
    content:
      '杨瑞文先生 2000年毕业于广东工业大学建筑设备工程系，毕业后一直从事暖通空调设计工作，参与设计国内多个高端星级酒店、会所及地产项目，有丰富的实践经验，可为业主提供机电系统的一站式设计服务，为项目的可实施性提供专业的可靠的技术保障。',
    awards:
      '',
  },
  {
    id: 10,
    cover: require('@/assets/images/demo1/about/t-10.jpg'),
    name: {
      cn: '安冬',
      en: 'antoine migueres',
    },
    title: {
      cn: '建筑设计师',
      en: 'Architectural designer',
    },
    content: '安冬先生，相信不同的文化背景可以带给设计不同的风格与感受。设计上，可以驾驭不同地域的风格并同时满足使用者的需求。',
    awards:
      'Ecole National Superieure d\'Architecture de Paris La Villette 硕士MArch\r\n广州美术学院建筑与环境艺术设计 硕士MA\r\n2018美景-东望展示中心\r\n2018 东驿敦煌 东-美术馆\r\n2019杭州野生动物园主题酒店建筑设计\r\n2019中国广东省广州市凯得君澜度假酒店建筑设计\r\n2020中国广东省佛山市君御游艇会建筑设计',
  },
  {
    id: 11,
    cover: require('@/assets/images/demo1/about/t-11.jpg'),
    name: {
      cn: '李玲俐',
      en: 'li lingli',
    },
    title: {
      cn: '建筑设计师',
      en: 'Architectural designer',
    },
    content:
      '在我看来，文化的本质是故事，而建筑和城市是文化的载体，建筑的展现着城市的过去、现在和未来。而我希望自己能够通过建筑的方式，来阅读一个城市的故事，来展示城市的文化。',
    awards:
      '广州美术学院建筑与环境艺术设计 硕士MA\r\n比利时鲁汶大学建筑学 硕士MArch\r\n2018柑甜小镇--湖北宜昌诗意居住住宅区\r\n2018美景-东望展示中心\r\n2018 东驿敦煌 东-美术馆\r\n2019杭州野生动物园主题酒店建筑设计\r\n2019中国广东省广州市凯得君澜度假酒店建筑设计\r\n',
  },
  {
    id: 12,
    cover: require('@/assets/images/demo1/about/t-12.jpg'),
    name: {
      cn: '庞典',
      en: 'pang dian',
    },
    title: {
      cn: '建筑设计师',
      en: 'Architectural designer',
    },
    content:
      '庞典先生，坚信空间的感动来自细节，注重设计中人与空间的关系，设计上，强调空间中使用者的体验感，追求设计与内心感受的同步。',
    awards:
      '广州美术学院建筑与环境艺术设计 硕士MFA\r\n旧金山艺术大学建筑与室内设计 硕士MA\r\n2017内蒙古通辽市马头琴文化博物馆室内设计\r\n2018 东驿敦煌 东-美术馆\r\n2019杭州野生动物园主题酒店建筑设计\r\n2019中国广东省广州市凯得君澜度假酒店建筑设计\r\n2019 深圳华润财富中心FUSION健身会所室内设计\r\n2020中国广东省佛山市君御游艇会建筑设计',
  },
];

Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

Object.keys(directives).forEach((key) => {
  Vue.directive(key, directives[key]);
});

Vue.use(baseFn).use(waterfall);

const ieVersion = Vue.prototype.IEVersion();
if (ieVersion === -1) {
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount('#app');
} else {
  // ie 不兼容提示
  const hintContainer = document.getElementById('browser-ie-hint-container');
  hintContainer.style.display = 'block';
  hintContainer.querySelector('.version').innerHTML = ieVersion;
}
